import AOPOrderBookPresenter from "@adapters/features/OrderBook/Presenters/AOPOrderBook";
export default (function (useCases) {
    return {
        aopOrderBook: new AOPOrderBookPresenter(useCases.aopOrderBook),
    };
});
